export const resetLocationState = () => {
   window.history.replaceState({}, '');
};
